import { useState } from "react";

import { DEVICE_ACTIONS } from "components/Actions/types/enums";
import { DialogProps } from "components/Actions/types/interfaces";
import { TRI_SOURCES } from "shared/types/enums";

import DialogActions from "../../components/DialogActions";
import TriSource from "../../components/TriSource/TriSource";
import CanPackageDropdown from "../../ProductCodes/components/CanPackageDropdown";
import { DropdownValue } from "../../types";
import { useTriSourceAction } from "../hooks/useTriSourceAction";

const AssignCanPackage = ({ isOpen, close }: DialogProps) => {
    const {
        t,
        rootCompany,
        isSupportUser,
        activeSource,
        sourcePayload,
        isSourceReady,
        isSelectedSingleItem,
        updateDevices
    } = useTriSourceAction();

    const [isLoading, setIsLoading] = useState(false);
    const [canPackage, setCanPackage] = useState<DropdownValue | null>(null);

    const isReady = isSourceReady && sourcePayload !== null;

    const handleCloseDialog = () => close(DEVICE_ACTIONS.AssignCanPackage);

    const handleChangePackage = (option: DropdownValue | null) =>
        setCanPackage(option);

    const getFormData = () => {
        const formData = new FormData();

        formData.append("source", activeSource);
        formData.append("file", sourcePayload as Blob);

        isSupportUser && formData.append("root_id", String(rootCompany?.id));

        formData.append(
            "data[can_package_id_override]",
            String(canPackage?.id ?? null)
        );

        return formData;
    };

    const getPayloadData = () => {
        const data = {
            can_package_id_override: canPackage?.id ?? null
        };

        const payload = {
            source: activeSource,
            [activeSource]: sourcePayload,
            data
        };

        return isSelectedSingleItem ? data : payload;
    };

    const handleSubmit = () => {
        const payloadData =
            activeSource === TRI_SOURCES.FromFile
                ? getFormData()
                : getPayloadData();

        updateDevices(payloadData, setIsLoading, handleCloseDialog);
    };

    const isBulkActionLoading = !isSelectedSingleItem && isLoading;

    return (
        <TriSource
            title={t("General##assign can package")}
            description={t("Dialog##assign can package description")}
            confirmationDescription={t(
                "Dialog##confirmations##assign can package confirmation"
            )}
            close={handleCloseDialog}
            isBulkActionLoading={isBulkActionLoading}
            open={isOpen}
            submit={handleSubmit}
            actions={
                <DialogActions
                    onClose={handleCloseDialog}
                    isLoading={isBulkActionLoading || isLoading}
                    loaderText={
                        !isSelectedSingleItem
                            ? t("Button##assigning")
                            : undefined
                    }
                    isReadyToConfirm={isReady}
                    confirmationButtonText={t("Button##assign")}
                />
            }
            isLoading={isLoading}
            slotProps={{
                transition: {
                    onExited: () => {
                        setIsLoading(false);
                        setCanPackage(null);
                    }
                }
            }}
        >
            <CanPackageDropdown
                isSubmitLoading={isLoading}
                change={handleChangePackage}
                readOnly={isLoading}
                customStyle={{
                    marginBottom: "16px"
                }}
            />
        </TriSource>
    );
};

export default AssignCanPackage;
